import { render, staticRenderFns } from "./editReasonMsgBox.vue?vue&type=template&id=5a9a652c&scoped=true&"
import script from "./editReasonMsgBox.vue?vue&type=script&lang=js&"
export * from "./editReasonMsgBox.vue?vue&type=script&lang=js&"
import style0 from "./editReasonMsgBox.vue?vue&type=style&index=0&id=5a9a652c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a652c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
